export default {
    webtitle: "Firma a kontakty - DOFFERO®",
    information_text_1: "Informacie boli uložené.",

    firmakontakt_text_1: "Firma a kontakty",
    firmakontakt_text_2: "Nastav si údaje , ktoré sa týkajú tvojej firmy a budú sa zobrazovať v tvojich ponukách. Tieto info môžeš kedykoľvek zmeniť.",
    firmakontakt_text_3: "Základné údaje",
    firmakontakt_text_4: "Logo a pečiatka",
    firmakontakt_text_5: "Kontaktná osoba",
    firmakontakt_text_6: "Základné údaje na kontaktnú osobu, ktoré sa zobrazia v ponuke. Môžeš ich zmeniť aj v ponuke.",
    firmakontakt_text_7: "Firemné údaje",
    firmakontakt_text_8: "Niektoré údaje vieme vyplniť automaticky. Zadaj IČO alebo názov firmy.",
    firmakontakt_text_9: "Sociálne siete",
    firmakontakt_text_10: "Nastav si linky na tvoje sociálne siete a tieto sa zobrazia v pätičke ponuky",
    firmakontakt_text_11: "Templaty ponúk",
    firmakontakt_text_12: "Viditelne iba pre admin užívateľa",
    firmakontakt_text_13: "Uložiť",

    
    firemneudaje_text_1: "Názov spoločnosti",
    firemneudaje_text_2: "IČO",
    firemneudaje_text_3: "DIČ",
    firemneudaje_text_4: "IČ DPH",
    firemneudaje_text_5: "ULICA A ČÍSLO sídla firmy",
    firemneudaje_text_6: "psč sídla firmy",
    firemneudaje_text_7: "MESTO sídla firmy",

    kontaktnaosoba_text_1: "meno kontaktnej osoby",
    kontaktnaosoba_text_2: "Telefónne číslo",
    kontaktnaosoba_text_3: "kontaktný E-MAIL",
    kontaktnaosoba_text_4: "Tento e-mail môže byť iný ako tvoj prihlasovací e-mail. Používa sa ako kontaktný e-mail v ponuke.",

    logo_text_1: "Vlož logo presunutím",
    logo_text_2: "Vlož logo presunutím",
    logo_text_3: "Vlož logo presunutím",
    logo_text_4: "alebo",
    logo_text_5: "Vybrať logo",
    logo_text_6: "Vymazať",
    logo_text_7: "Stiahnuť",
    logo_text_8: "Naozaj chcete vymazať logo?",
    logo_text_9: "Je možné nahrať len jedno logo. Prosím, najskôr vymažte pôvodné.",
    logo_text_10: "Iba {extensions} soubory môžu byť nahranté.",
    logo_text_11: "{name} je príliš velký! Prosím, výberte soubor do velikosti {fileMaxSize} MB.",

    nazovslug_text_1: "Názov tvojej firmy / ZNAČKY",
    nazovslug_text_2: "Podľa tohto názvu sa vygeneruje URL adresa tvojich ponúk, ale môžeš to zmeniť.",
    nazovslug_text_3: "Tvoj odkaz na cenovú ponuku bude vyzerať nasledovne:",
  
    signature_text_0: "pečiatka / Podpis",
    signature_text_1: "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím <br> alebo <span class='nahraj'>nahraj podpis</span>",
    signature_text_2: "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím <br> alebo <span class='nahraj'>nahraj podpis</span>",
    signature_text_3: "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím <br> alebo <span class='nahraj'>nahraj podpis</span>",
    signature_text_4: "",
    signature_text_5: "",
    signature_text_6: "Vymazať",
    signature_text_7: "Stiahnuť",
    signature_text_8: "Naozaj chcete vymazať podpis?",
    signature_text_9: "Je možné nahrať len jeden podpis. Prosím, najskôr vymažte pôvodné.",
    signature_text_10: "Iba {extensions} soubory môžu byť nahranté.",
    signature_text_11: "{name} je príliš velký! Prosím, výberte soubor do velikosti {fileMaxSize} MB.",

    webtel_text_1: "Webová stránka firmy",
    webtel_text_2: "Telefónne číslo",
    webtel_text_3: "Som platca DPH",
    webtel_text_4: "Nastav si či si platca DPH, aby sme do tvojich ponúk dávali správne ceny.",
    webtel_text_5: "Nastaviť ceny s ",
    webtel_text_6: " % DPH",
}